import { Component, EventEmitter, Input, Output, HostBinding } from '@angular/core';

export type ToolbarPosition = 'top' | 'bottom' | 'left' | 'right';

@Component({
  selector: 'kt-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {
  @Input() totalSelectedItems: number = 0;
  @Input() itemLabel: string = 'items';
  /** Position where the toolbar is anchored. Horizontal: top | bottom. Vertical: left | right. Defaults to bottom. */
  @Input() position: ToolbarPosition = 'bottom';

  @Output() clearSelection = new EventEmitter<void>();

  @HostBinding('class') get positionClass(): string {
    return `kt-toolbar--${this.position}`;
  }

  get isVertical(): boolean {
    return this.position === 'left' || this.position === 'right';
  }

  onClearSelection() {
    this.clearSelection.emit();
  }
}
